import { render, staticRenderFns } from "./WyRace.vue?vue&type=template&id=2327d4d0&scoped=true"
import script from "./WyRace.vue?vue&type=script&lang=js"
export * from "./WyRace.vue?vue&type=script&lang=js"
import style0 from "./WyRace.vue?vue&type=style&index=0&id=2327d4d0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2327d4d0",
  null
  
)

export default component.exports